import bem from '../../../utils/bem';

const Icon = ({
  iconName,
  iconTitle,
  width = 48,
  height = 48,
  className,
  style,
}) => {
  const path = window.isStoryBook ? '' : '/themes/custom/sgna/dist/';
  return (
    <svg
      className={bem('icon', [], '', [className])}
      width={width}
      height={height}
      aria-hidden="true"
      style={style}
      role="img"
    >
      {iconTitle ? <title>{iconTitle}</title> : ''}
      <use href={`${path}icons.svg#${iconName}`}></use>
    </svg>
  );
};

export default Icon;
